export default __webpack_public_path__ + "static/media/icon-sort-active-down.eb5062ce.svg";